export const PRODUCT_TAG_BAPTISM = "bautismo";
export const PRODUCT_TAG_BRONZE_PACKAGE = "bronce";
export const PRODUCT_TAG_SNOWBOARD_LESSON = "snowboard";
export const PRODUCT_TAG_JUNIOR_PACKAGE = "junior";
export const PRODUCT_TAG_SILVER_PACKAGE = "plata";
export const PRODUCT_TAG_GOLD_PACKAGE = "oro";
export const SKI_POLES = "bastones";
